module.exports = __webpack_public_path__ + "img/tianjia.705126d8.svg";